import { useEffect, useState } from "react";

export function useApplePay() {
  const [isReady, setIsReady] = useState(false);
  const isAndroidOrWindows = /android|windows/i.test(navigator.userAgent);

  useEffect(() => {
    if (isAndroidOrWindows) return;

    const applePayJSLoadedPromise = new Promise(resolve => {
      const element = document.createElement("script");
      element.addEventListener("load", resolve, { once: true });

      //NOTE: USING THE LATEST VERSION
      element.src = "https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js"
      element.crossOrigin = "anonymous";
      document.head.appendChild(element);
    });

    //NOTE: canMakePayments returns true if the device supports Apple Pay and the user has added a payment card to their device.
    applePayJSLoadedPromise
      .then(() => {
        if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
          setIsReady(true);
        }
      })
      .catch((e) => {
        console.log("INITIALIZE APPLE PAY ERROR", e)
        setIsReady(false)
      });
  }, []);

  return isReady;
}
